import type {
  DefaultResponseBody,
  ListResponseBody,
  RadioLiveChannel,
  RadioLiveNowPlaying,
  RadioLiveScheduleEntry,
} from "@gerama/types";
import type { ApiClient } from "../client";

/** `/radio` — always-on channels: every listener computes the same "now playing" from the channel's clock. */
export function createCoreRadioApi(client: ApiClient) {
  return {
    list: (signal?: AbortSignal) =>
      client
        .request<ListResponseBody<RadioLiveChannel>>("/radio", { signal })
        .then((res) => res.data?.list ?? []),

    detail: (id: number, signal?: AbortSignal) =>
      client
        .request<DefaultResponseBody<RadioLiveChannel>>(`/radio/${id}`, { signal })
        .then((res) => res.data as RadioLiveChannel),

    nowPlaying: (id: number, signal?: AbortSignal) =>
      client
        .request<DefaultResponseBody<RadioLiveNowPlaying>>(`/radio/${id}/now-playing`, { signal })
        .then((res) => res.data as RadioLiveNowPlaying),

    schedule: (id: number, hours = 6, signal?: AbortSignal) =>
      client
        .request<ListResponseBody<RadioLiveScheduleEntry>>(`/radio/${id}/schedule`, {
          query: { hours },
          signal,
        })
        .then((res) => res.data?.list ?? []),

    /** About once a minute while listening — feeds the live-listener count. */
    heartbeat: (id: number) =>
      client
        .request<DefaultResponseBody<{ listeners: number }>>(`/radio/${id}/heartbeat`, {
          method: "POST",
        })
        .then((res) => res.data),

    songStreamUrl: (id: number) => `${client.baseUrl}/songs/${id}/stream`,
    videoStreamUrl: (id: number) => `${client.baseUrl}/videos/${id}/stream`,
  };
}
